import { rem } from '@mantine/core';

interface IconCFDI extends React.ComponentPropsWithoutRef<'svg'> {
  size?: number | string;
}

export function IconCFDI({ size, style, ...others }: IconCFDI) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      fill="currentColor"
      viewBox="0 0 512 512"
      enableBackground="0 0 512 512"
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}>
      <g
        transform="translate(0.000000,835.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M2310 8320 c-319 -67 -528 -274 -608 -599 -14 -59 -16 -200 -19
-1310 l-4 -1244 83 6 c46 4 145 7 220 7 l138 0 2 1228 3 1227 23 56 c46 114
145 187 282 209 41 6 468 10 1168 10 l1102 0 0 -688 c0 -413 4 -721 10 -772
31 -250 136 -445 310 -573 62 -45 179 -98 278 -125 l97 -26 768 -4 767 -3 0
-1396 c0 -1219 -2 -1394 -15 -1390 -8 4 -61 11 -117 17 -450 49 -901 -200
-1108 -610 -60 -119 -89 -218 -115 -383 l-6 -37 -1587 2 -1587 3 -59 24 c-116
46 -178 128 -210 274 l-6 27 -216 0 -217 0 7 -61 c10 -81 49 -217 85 -287 99
-196 265 -325 500 -390 l96 -27 1625 -3 1625 -3 28 -71 c82 -213 260 -419 466
-541 265 -157 587 -198 889 -111 345 99 631 374 748 718 76 223 75 493 -2 726
-55 164 -176 346 -309 466 l-75 67 0 1630 c0 1154 -3 1642 -11 1671 -10 36
-143 172 -1128 1154 -763 762 -1129 1120 -1156 1133 -39 18 -87 19 -1360 18
-1236 0 -1325 -2 -1405 -19z m4214 -2158 c-66 -1 -342 -1 -614 0 l-495 3 -60
24 c-80 32 -154 106 -186 186 l-24 60 -3 609 -3 609 752 -744 751 -744 -118
-3z m306 -3642 c87 -17 100 -26 100 -66 0 -30 -3 -35 -17 -29 -119 46 -320 47
-438 1 -199 -77 -357 -255 -397 -447 -12 -58 -13 -59 -45 -59 -24 0 -33 5 -33
16 0 38 34 143 70 213 144 282 449 431 760 371z m545 -531 c35 -148 11 -329
-62 -478 -50 -102 -187 -241 -288 -293 -196 -100 -388 -112 -586 -37 -127 49
-272 165 -332 268 l-18 31 38 0 c33 0 43 -6 73 -45 70 -90 189 -169 310 -207
103 -32 264 -32 365 -1 120 38 244 123 315 217 96 127 133 250 129 421 -2 72
2 128 11 163 16 61 22 55 45 -39z"
        />
        <path
          d="M2855 6956 c-39 -17 -80 -65 -95 -111 -23 -70 11 -155 78 -197 l37
-23 565 0 565 0 37 23 c94 58 112 178 40 264 -50 59 -40 58 -644 58 -437 -1
-559 -4 -583 -14z"
        />
        <path
          d="M2850 6128 c-117 -60 -130 -214 -24 -294 l37 -29 551 -3 c303 -2 566
0 584 3 18 3 50 22 71 43 92 87 73 223 -39 280 l-44 22 -546 0 -546 0 -44 -22z"
        />
        <path
          d="M340 4841 c-91 -28 -164 -91 -208 -180 l-27 -56 0 -890 0 -890 22
-47 c30 -66 96 -133 162 -165 l56 -28 2220 -8 c1221 -4 2360 -6 2530 -5 301 3
311 4 356 26 75 37 125 87 161 160 l33 67 3 835 c2 560 -1 858 -8 904 -19 123
-78 203 -190 255 l-55 26 -2515 2 c-1383 1 -2526 -2 -2540 -6z m1286 -485 c34
-8 72 -20 86 -27 l25 -11 -27 -110 c-16 -60 -31 -112 -34 -115 -3 -3 -27 3
-53 12 -73 26 -254 32 -329 10 -181 -53 -283 -200 -284 -411 -1 -271 159 -434
425 -434 58 0 189 20 226 35 13 5 20 -12 38 -105 12 -60 20 -114 17 -119 -10
-16 -125 -42 -229 -51 -338 -30 -600 92 -716 331 -55 115 -75 222 -68 363 9
196 73 342 202 465 102 97 229 157 380 181 78 12 263 4 341 -14z m1964 -10
c215 -41 369 -148 449 -312 45 -92 61 -171 61 -304 0 -215 -57 -370 -184 -496
-112 -112 -249 -168 -477 -195 -101 -12 -376 -7 -461 7 l-38 7 0 643 0 643 46
7 c172 25 472 26 604 0z m-870 -111 l0 -125 -250 0 -250 0 0 -150 0 -150 235
0 236 0 -3 -117 -3 -118 -232 -3 -233 -2 -2 -263 -3 -262 -147 -3 -148 -3 0
661 0 660 400 0 400 0 0 -125z m1875 -535 l0 -655 -147 -3 -148 -3 0 661 0
661 148 -3 147 -3 0 -655z"
        />
        <path
          d="M3268 4133 l-28 -4 0 -429 c0 -484 -9 -440 88 -440 312 0 477 179
459 495 -14 247 -144 372 -392 380 -55 2 -112 1 -127 -2z"
        />
        <path
          d="M5405 830 l-260 -260 283 0 282 0 0 -282 0 -283 305 305 c168 168
305 308 305 312 0 3 -24 14 -52 24 -76 24 -201 89 -288 147 -81 55 -227 191
-275 256 -16 22 -32 41 -35 41 -3 0 -122 -117 -265 -260z"
        />
        <path
          d="M7655 1021 c-131 -158 -301 -280 -499 -360 l-94 -38 304 -304 304
-304 0 277 0 278 280 2 280 3 -258 258 -258 258 -59 -70z"
        />
      </g>
    </svg>
  );
}
